import { LitElement, html, css } from './lit-core.min.js';

class WishlistAddButtonByob extends LitElement {
	static properties = {
		viewWishlist: { type: Boolean },
		bundleId: { type: String },
		bundleItems: { type: Array },
		label: { type: Boolean }
	}

	constructor() {
		super();
		this.viewWishlist = false;
		this.label = false;
		window.addEventListener('wishlistupdate', () => this.requestUpdate());
	}

	createRenderRoot() {
		return this;
	}

	willUpdate(changedProperties) {
		let added = window.wishlist != undefined ? window.wishlist.hasItem(this.bundleId) : false;
		if (!added) this.viewWishlist = false;
	}

	render() {
		let added = window.wishlist != undefined ? window.wishlist.hasItem(this.bundleId) : false;

		return html`
			<button @click=${this.toggle} style="border: none; ${!this.label ? 'background: none;' : ''}" class="
				wishlist-add-button 
				${this.label ? 'wishlist-add-button--has-label' : ''}
				loaded
				${added ? 'added' : ''}
				${added && this.viewWishlist ? 'wishlist-add-button--view-wishlist ' : ''}
			">
				<svg width="22" height="18" viewBox="0 -1 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M21.6764 7.16497C21.4818 7.90732 21.0952 8.58534 20.5554 9.13084L12.0908 17.5792L3.62616 9.13084C3.35033 8.85304 3.11019 8.54196 2.9113 8.20477C2.72415 7.87118 2.57691 7.51673 2.47263 7.14872C2.38939 6.78076 2.34581 6.40493 2.34266 6.02769C2.34486 5.63965 2.38843 5.25295 2.47263 4.87416C2.57385 4.50509 2.72124 4.15027 2.9113 3.81811C3.10626 3.47693 3.34672 3.16823 3.62616 2.89204C4.04354 2.48025 4.53387 2.14969 5.07214 1.91723C6.1568 1.48331 7.36682 1.48331 8.45149 1.91723C8.98763 2.13981 9.47179 2.46637 9.88121 2.87579L12.0908 5.10161L14.3004 2.87579C14.7095 2.46564 15.1953 2.13994 15.7301 1.91723C16.8147 1.48331 18.0248 1.48331 19.1094 1.91723C19.6472 2.14956 20.1379 2.48099 20.5554 2.89204C20.8381 3.16011 21.0753 3.47205 21.254 3.81811C21.6303 4.48173 21.8264 5.23231 21.8227 5.99519C21.8448 6.38775 21.812 6.78148 21.7252 7.16497H21.6764Z" 
							fill="transparent"
							stroke="#212121"
							stroke-width="1.8"
					/>
				</svg>
				<span class="wishlist-add-button__label">
						${added ? 'Added to Wishlist!' : 'Add to Wishlist'}
				</span>
				<a href="/pages/wishlist">View Wishlist</a>
			</button>
		`;
	}

	async toggle() {
		if (this.viewWishlist) return;
		const wishlist = window.wishlist;

		if (wishlist.hasItem(this.bundleId)) {
			wishlist.remove(this.bundleId);
			window.trackEvent('BYOB', 'RFW', 'RFW-BYOB');
		}
		else {
			this.viewWishlist = false;

			await wishlist.add({
				id: this.bundleId,
				isByob: true,
				variant: this.dataset.variantId,
				image: this.dataset.image,
				url: this.dataset.url,
				items: this.bundleItems,
				title: this.dataset.title,
				discount: parseFloat(this.dataset.discount),
				handle: this.dataset.handle
			});

			if (this.label) setTimeout(() => this.viewWishlist = true, 5000);
			window.trackEvent('BYOB', 'ATW', 'ATW-BYOB', this.bundleItems.map(item => item.sku).join(','));
			window.trackFSEvent('BYOB Add To Wishlist', {
				skus: this.bundleItems.map(item => item.sku)
			});
		}

		this.requestUpdate();
	}
}

class WishlistItemByob extends LitElement {
	static properties = {
		showItems: { type: Boolean },
		bundleItems: { type: Array },
		price: { type: String },
		quantity: { type: Number },
		preorder: { type: Boolean },
		cartImage: { type: String },
		comingSoon: { type: Boolean },
	}

	constructor() {
		super();
		this.bundleItems = [];
		this.showItems = false;
		this.price = '';
		this.quantity = 1;
		this.preorder = false;
		this.cartImage = '';
		this.comingSoon = false;
	}

	createRenderRoot() {
		return this;
	}

	async connectedCallback() {
		let price = 0;
		let bundleItems = [];

		// Wait for wishlist to be available
		if (window.wishlist == undefined) {
			await new Promise(resolve => {
				const interval = setInterval(() => {
					if (window.wishlist) {
						clearInterval(interval);
						resolve();
					}
				}, 100);
			});
		}

		this.wishlistData = window.wishlist.getItem(this.dataset.id);
		this.index = [...this.closest('wishlist-contents').querySelectorAll('.wishlist-item')].indexOf(this);

		if (this.wishlistData.image.includes('http://') || this.wishlistData.image.includes('bedthreads')) this.showItems = true; // Expand items if using fallback image

		const query = /* GraphQL */ `
			query variantQuery($ids: [ID!]!) {
				nodes(ids: $ids) {
					... on ProductVariant {
						id
						price {
							amount
							currencyCode
						}
						selectedOptions {
							name
							value
						}
						image {
							url
						}
						product {
							title
							handle
							tags
						}
						quantityAvailable
					}
				}
			}
		`;

		let ids = this.wishlistData.items.map(item => `gid://shopify/ProductVariant/${item.variant}`);

		let resp = await fetch('/api/2023-04/graphql.json', {
			method: 'POST',
			headers: {
					'Content-Type': 'application/json',
					'X-Shopify-Storefront-Access-Token': theme.storefrontToken
			},
			body: JSON.stringify({query: query, variables: {ids: ids}})
		});

		let json = await resp.json();
		let variants = json.data.nodes;

		for (let variant of variants) {
			let variantId = variant.id.replace('gid://shopify/ProductVariant/', '');
			let variantPrice = parseFloat(variant.price.amount) * 100

			let options = variant.selectedOptions
				.filter(option => option.name != 'Type' && option.name != 'Colour');

			let bundleItem =  {
				title: variant.product.title,
				options: options,
				image: `${variant.image.url}&width=280`,
				thumb: `${variant.image.url}&width=100`,
				price: variantPrice,
				variant: variantId,
				url: `/products/${variant.product.handle}?variant=${variantId}`
			};

			price += variantPrice;
			bundleItems.push(bundleItem);

			if (variant.quantityAvailable <= 0) {
				this.preorder = true;

				fetch(`/products/${variant.product.handle}?variant=${variantId}&view=preorder-month`)
					.then(resp => resp.text())
					.then(text => this.preorderMonth = text.trim())
			}

			if (variant.product.tags.includes('ComingSoon')) {
				this.comingSoon = true;
			}
		}

		this.classList.remove('wishlist-item--placeholder');
		this.innerHTML = '';

		this.bundleVariant = this.wishlistData.variant;
		this.bundleItems = bundleItems;
		const discountMultiplier = 1 - (this.wishlistData.discount != undefined ? this.wishlistData.discount : 0.2);
		this.price = price * discountMultiplier;

		super.connectedCallback();	
		this.classList.add('fade-in');
		setTimeout(() => this.classList.remove('fade-in'), 500);

		this.dispatchEvent(new CustomEvent('wishlistitemloaded', { bubbles: true }));

		let productData = await fetch(`${this.wishlistData.url}.js`).then(resp => resp.json());
		this.cartImage = this.wishlistData.image;
	}

	async addToCart() {
		this.style.pointerEvents = 'none';
		let button = this.querySelector('.wishlist-item__atc');
		button.classList.add('show-loading');

		let info = await this.getAtcInfo();
		await addAllToCart(info);

		window.updateCartDrawer();

		let signifier = this.querySelector('.cart-signifier');
		signifier.classList.add('active');
		setTimeout(() => signifier.classList.remove('active'), 4000);

		button.classList.remove('show-loading');
		this.classList.add('added');
		this.dispatchEvent(new CustomEvent('wishlistitematc', {bubbles: true, detail: {item: this}}));

		this.style.pointerEvents = '';
	}

	async getAtcInfo() {
		const discount = 1 - (this.wishlistData.discount != undefined ? this.wishlistData.discount : 0.2);
		let items = [];

		const image = this.wishlistData.image;
		let imageUrl = null;

		if (image.includes('base64')) {
			const resp = await fetch('https://bundle-images.bedthreads.workers.dev/', {
				method: 'POST',
				body: JSON.stringify({image: image})
			});

			if (resp.ok) {
				const json = await resp.json();
				if (json.url) imageUrl = json.url;
			}
		}

		for (let i = 0; i < this.quantity; i++) {
			let bundleId = parseInt(this.dataset.id) + i;

			for (let item of this.bundleItems) {
				const cartItem = {
					variantId: item.variant,
					quantity: 1,
					properties: {
						_ItemPrice: item.price * discount,
						_BundleDiscount: item.price - (item.price * discount),
						_BundleIndex: this.bundleItems.indexOf(item)
					}
				}

				cartItem.properties['_PartOf'] = 'Build Your Own Bundle';
				cartItem.properties['_BundleId'] = `${this.bundleVariant}/${bundleId}`;
				if (imageUrl) cartItem.properties['_BundleImage'] = imageUrl;
				if (this.preorderMonth) cartItem.preorderMonth = this.preorderMonth;

				items.push(cartItem);
			}
		}

		items.reverse();

		return items;
	}

	canAddToCart() {
		if (this.preorder) return false;
		else return true;
	}

	async remove(removeFromWishlist = true, fireEvent = true, transition = true) {
		if (transition) {
				this.classList.add('transition-out');
				setTimeout(() => {
						this.classList.remove('transition-out');
						this.classList.add('hide');
				}, 250);
		}
		else this.classList.add('hide');

		if (removeFromWishlist) await window.wishlist.remove(this.dataset.id);
		this.showItems = false;
		if (fireEvent) this.dispatchEvent(new CustomEvent('wishlistitemremove', {bubbles: true, detail: {item: this}}));
	}

	render() {
		if (this.bundleItems.length == 0) return;
		let itemsCount = this.bundleItems.length;
		return html`
			<img 
				class="wishlist-item__image" 
				src="${this.wishlistData.image}" 
				width="400" height="${400 * 0.8}"
				loading="lazy"
				style="background-image: url('${this.wishlistData.image.replace('width=400', 'width=150')}'); background-size: 100%;"
			/>
			<div class="wishlist-item__details">
        <h3 class="wishlist-item__name"><a href="${this.wishlistData.url}?wishlist=${this.dataset.id}">${this.wishlistData.title}</a></h3>
        <div class="wishlist-item__price card-body">${theme.moneyFormat.replace('{{amount}}', (this.price / 100).toFixed(2))}</div>
				<a href="${this.wishlistData.url}?wishlist=${this.dataset.id}" class="wishlist-item__edit">Edit this Bundle</a>
			</div>
			<button class="wishlist-item__remove" @click=${() => this.remove()}>
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.2053 8.99966L4.10242 13.1014L4.8978 13.8979L9.00067 9.79504L13.1024 13.8979L13.8989 13.1025L9.79605 8.99966L13.8989 4.89791L13.1024 4.10254L9.00068 8.20429L4.89892 4.10254L4.10242 4.89791L8.2053 8.99966Z" fill="#212121"/>
        </svg>  
    	</button>
			${this.comingSoon ? html`
				<button name="add" class="wishlist-item__atc" disabled>
					<span class="add">Coming Soon</span>
				</button>
			` : html`
				<button name="add" class="wishlist-item__atc" @click=${this.addToCart}>
					<span class="add">${this.preorder ? ' Pre-Order Now' : 'Add to Cart'}</span>
					<span class="added">Added to Cart</span>
				</button>
			`
			}
			<div class="wishlist-item__qty">
        <button class="wishlist-item__qty-decrease" aria-label="Decrease Quantity" @click=${() => this.quantity = Math.max(1, this.quantity - 1)}>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.91675 6.41699H11.0834V7.58366H2.91675V6.41699Z" fill="black" fill-opacity="0.6"/>
            </svg>
        </button>
        <span class="wishlist-item__qty-count">${this.quantity}</span>
        <button class="wishlist-item__qty-increase" aria-label="Increase Quantity" @click=${() => this.quantity = this.quantity + 1}>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.43716 7.43708L11.9495 7.43769L11.9501 6.56221L7.43716 6.56221L7.43778 2.04989L6.5623 2.04928L6.5623 6.56221L2.04998 6.56159L2.0506 7.43708L6.5623 7.43708L6.5623 11.9488L7.43778 11.9494L7.43716 7.43708Z" fill="black" fill-opacity="0.6"/>
            </svg>
        </button>
			</div>
			<button class="wishlist-item__toggle-bundle" name="${this.showItems ? 'hide' : 'show'}" @click=${() => this.showItems = !this.showItems}>
				${this.showItems ? 'Hide' : 'Show'} Bundle Items
			</button>
			<ul class="wishlist-item__bundle-items ${this.showItems ? 'expanded' : ''}" style="--rows-desktop: ${Math.ceil(itemsCount / 6)}; --rows-tablet: ${Math.ceil(itemsCount / 4)}; --rows: ${Math.ceil(itemsCount / 3)};">
				${this.bundleItems.map(item => html`
					<li>
						<img src="${item.image}" width="180" height="${180 / 0.8}" loading="lazy" style="background-image: url('${item.thumb}'); background-size: 100%;"/>
						<h4><a href="${item.url}">${item.title}</a></h4>
						${item.options.map(option => html`
							<p>${option.value}</p>
						`)}
					</li>
				`)}
			</ul>
			<div class="cart-signifier">
				<span class="cart-signifier__atc-check"></span>
				<div class="cart-signifier__atc">Added to cart</div>
				<div class="cart-signifier__container">
					<div class="cart-signifier__image">
						<img src="${this.cartImage}" alt="">
					</div>
					<div class="cart-signifier__header">
						<div class="cart-signifier__title">${this.wishlistData.title}</div>
					</div>
				</div>
				<div>
					<a href="#" class='btn signifier-cart' onClick="window.showCartDrawer(true); return false;">View Cart</a>
					<a href="/checkout" class='btn signifier-checkout checkout-btn-cta'>Checkout</a>
				</div>
			</div>
		`
	}
}

customElements.define('wishlist-add-button-byob', WishlistAddButtonByob);
customElements.define('wishlist-item-byob', WishlistItemByob);